/* this component is for Edge onboarding */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCompanyEnrollmentInfo } from '../common/useCompanyEnrollmentInfo';
import { useSolutionOrg } from '../config/useSolutionOrg';
import { ServiceNationSolutionOrgName } from '../common/constants';
import { PARTNERS_ROUTE } from '../routes/namedRoutes';
import AuthenticatedRoute from './AuthenticatedRoute';
import { Home } from './Home';

function HomeWrapperInner() {
  const navigate = useNavigate();
  const { solutionOrgName } = useSolutionOrg();

  // check company enrollment status
  useCompanyEnrollmentInfo({
    calledFromOnboardingComponent: true,
    enableOnboardingFlowTestRedirect: true,
  });

  useEffect(() => {
    if (solutionOrgName === ServiceNationSolutionOrgName) {
      navigate(PARTNERS_ROUTE);
    }
  }, [solutionOrgName, navigate]);

  if (solutionOrgName === ServiceNationSolutionOrgName) {
    return null;
  }

  return <Home />;
}

export function HomeWrapper() {
  return (
    <AuthenticatedRoute>
      <HomeWrapperInner />
    </AuthenticatedRoute>
  );
}
